<template>
	<div id="page-index">
		<div class="page">
			<Navbar v-on:reset-analyze="resetVars"/>
			<!--Header-->
			<Header :home="true">
				<div class="header-text">
					<h2 class="cosmic-title">Stay Online, Stay Fast.</h2>
					<h1 class="cosmic-title">All-In-One DDoS Solution,<br>Optimized for Speed.</h1>
				</div>
			</Header>
			<!--Navigate Categories-->
		<section ref="sectionCatnav" class="section-catnav">
				<div class="container" :style="centeredContent">
					<div class="row">
						<div class="cat-text col-12 offset-md-3 col-md-8 col-lg-5 offset-lg-1">
							<h2>Cloud DDoS Solution</h2>
							<h1>See how we can protect your organization</h1>
							<p>In today’s digital era, your online presence is an invaluable asset to your organization.</p>
							<p>Cosmic Guard’s DDoS Mitigation platform is built to protect from the digital threats of tomorrow to secure your online assets.</p>
						</div>
						<div class="col-12 col-lg-6">
							<div class="flexbox">
								<router-link class="cat-links" to="/gaming">
									<button class="cat-buttons game-btn">
										<span>Gaming</span>
										<div class="small-text">
											<p>Supercharge your game server.</p>
											<p>View more ></p>
										</div>
									</button>
								</router-link>
								<router-link class="cat-links" to="/servers">
									<button class="cat-buttons servers-btn">
										<span>Servers</span>
										<div class="small-text">
											<p>Remote protection for your servers.</p>
											<p>View more ></p>
										</div>
									</button>
								</router-link>
								<router-link class="cat-links" to="/hosts">
									<button class="cat-buttons hosts-btn">
										<span>Hosts</span>
										<div class="small-text">
											<p>Protect customers from digital threats.</p>
											<p>View more ></p>
										</div>
									</button>
								</router-link>
								<router-link class="cat-links" to="/enterprise">
									<button class="cat-buttons enterprise-btn">
										<span>Enterprise</span>
										<div class="small-text">
											<p>Security that scales as fast as you do.</p>
											<p>View more ></p>
										</div>
									</button>
								</router-link>
							</div>
						</div>
					</div>
				</div>
			</section>
		</div>
		<Footer />
	</div>
</template>

<script lang="js">
import Navbar from '@/components/Navbar.vue';
import Header from "@/components/Header.vue";
import Footer from "@/components/Footer.vue";

export default {
	components: {
		Navbar,
		Header,
		Footer
	},
	data() {
		return {
			analyzing: false,
			catNav: undefined,
			catNavHeight: undefined,
		}
	},
	methods: {
		isAnalyzing(value) {
			this.analyzing = value;
		},
		resetVars(value) {
			this.isAnalyzing(value);
			this.$refs.analyzeCard.reset();
		},
		getContentHeight() {
			this.catNav = this.$refs.sectionCatnav;
			this.catNavHeight = this.$refs.sectionCatnav.clientHeight;
		}
	},
	computed: {
		centeredContent() {
			if(this.catNavHeight != undefined) {
				return {
					paddingTop: (this.catNavHeight - this.catNav.firstChild.clientHeight) / 2 + 'px !important',
				}
			}
			return {}
		}
	},
	mounted() {
		if (this.$route.params.id !== undefined) {
			let analyzeId = this.$route.params.id;
			this.$refs.analyzeCard.setIP(analyzeId);
			this.$refs.analyzeCard.submit();
		}

		this.$nextTick(function() {
			window.addEventListener('resize', this.getContentHeight);
			this.getContentHeight();
		})
	},
	beforeDestroy() {
		window.removeEventListener('resize', this.getContentHeight);
	}
};
</script>

<style scoped>
.header-text {
	padding-top: 5em;
	position: relative;
	z-index: 1;
}
.section-catnav {
	min-height: calc(100vh - 690px); /* screen height - (header height + footer height + navbar height) */
	margin: 2em 0;
}
.flexbox {
	display: flex;
	flex-wrap: wrap;
	justify-content: center;
	max-width: 30em;
	margin: 0 auto;
}
.cat-text {
	margin: auto;
}
.cat-text h1 {
	max-width: 16em;
}
.cat-text p {
	margin-bottom: 0.4em;
}
.cat-links {
	--button-size: 11em;
	width: var(--button-size);
	height: var(--button-size);
	min-height: var(--button-size);
	min-width: var(--button-size);
	margin: 1em;
}
.cat-buttons {
	position: relative;
	background: #3e78d3;
	width: 100%;
	height: 100%;
	padding: 1em;
	border-radius: 5px;
	font-weight: 400;
	font-size: 18px;
	background-size: cover;
	background-image: none;
    background-image: url('~@/assets/img/button-back.png');
	border: none;
	color: #fff;
	cursor: pointer;
	text-transform: none;
}
.cat-buttons span {
	display: block;
	text-align: left;
	font-weight: 600;
	font-size: 22px;
}
.cat-buttons p{
	text-align: left;
	font-size: 14px;
}

.game-btn {
    background-image: url('~@/assets/img/button-back-game.png');
}
.hosts-btn {
    background-image: url('~@/assets/img/button-back-hosts.png');
}
.servers-btn {
    background-image: url('~@/assets/img/button-back-servers.png');
}
.enterprise-btn {
    background-image: url('~@/assets/img/button-back-enterprises.png');
}
.cat-buttons::before {
	content: "";
	position: absolute;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
	background-color: rgba(144, 196, 255, 0.5);
	border-radius: 5px;
    opacity: 0;
	transition: 0.5s opacity;
}
.cat-buttons:hover::before {
    opacity: 1;
}
.cat-buttons span {
	position: relative;
}

.section-protection, .section-premium {
	margin-bottom: 4em;
}

@media only screen and (max-width: 576px) {
	.cat-text {
		padding: 0 2em;
	}
}
@media only screen and (max-width: 450px) {
	.cat-links {
		--button-size: 9em;
		margin: 0.5em;
	}
	.cat-buttons {
		padding: 0.5em 1em;
	}
	.cat-buttons p {
		font-size: 12px;
		margin-bottom: 5px;
	}
	.cat-buttons span {
		font-size: 16px;
	}
}
</style>